<template>
  <!-- 加工 -->
    <el-container class="layout-container-demo" >
      <!-- 顶部工具栏 -->
      <el-header  class="flexItems">
        <div class="btn-box" @click="outLogin">退出登录</div>

          <div class="flex goodsTabs">
              <span v-for="(item,index) in tabsMenu" class="tabsText" :key="index" @click="handleClick(index)" :class="{activeTabs:index===activeTab}" >{{item}}</span>
          </div>
          <el-select v-model="value" placeholder="Select" size="large" style="width: 11%;" class="supplierSelect" @change="selectSupplier($event,1)">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <div class="btn-box flexItems" @click="reload">
            <el-icon style="margin-right:5px;" size="30"><Refresh  /></el-icon>
            刷新订单
        </div>
        <!-- 占位符 -->
        <div style="flex:1"></div>
        <div class="btn-box" @click="handleMerge">{{!isMerge?'合并交换':'退出'}}</div>
        <el-icon @click="setClick" color="#fff" size="35" style="margin-left:30px"><Tools /></el-icon>
      </el-header>
        <!-- 内容 -->
        <div class="flex" >
          <!-- 左侧菜单 -->
          <el-aside width="11%" style="height:calc(100vh - 115px)">
            <el-scrollbar style="height: 100%;">
              <el-menu :default-active="menuActive" active-text-color="#fff" @select="handleSelect">
                <el-menu-item :index="index+''" v-for="(item,index) in menuList" :key="index" class="menu-item" >
                   {{item.cuttingTypeName}}
                </el-menu-item>
              </el-menu>
            </el-scrollbar>
          </el-aside>
          <!-- 右侧内容 -->
          <el-main style="padding:10px 10px 0 ;flex:1;height:calc(100vh - 115px)" >
            <el-scrollbar style="height: 100%;">
              <div v-for="(v,i) in tableData" :key="i"  class="entry-card-box">
                  <h4 class="cont-title">{{v.orderTypeName}}</h4>
                <div class="flex flexWrap">
                   <div  v-for="(item,index) in v.list" :key="index"  class="entry-card-item" >
                    <el-card shadow="always" class="cont-card" >
                        <div class="card-checkbox" v-if="isMerge&&item.scaleStatus==0">
                            <el-checkbox  v-model="item.checked" size="large" label=" "> </el-checkbox>
                        </div>
                      <div class="flex justifyBetween">
                          <div class="card-left">
                               <h3 class="card-title font-weight-bold">{{item.goodsName}}</h3>
                               <div class="font-weight-bold">工序：切{{item.cuttingTypeName}}</div>
                               <div class="font-weight-bold">出仓毛菜：{{GetNumByUnit(item.goodsGrossWeight,'g','kg')}}kg</div>
                               <div class="font-weight-bold">计划净菜：{{GetNumByUnit(item.goodsSuttleWeight,'g','kg')}}kg</div>
                               <div class="font-weight-bold">实际交货：{{item.scaleStatus==0?'-': GetNumByUnit(item.processWeight,'g','kg')}}kg</div>
                          </div>
                          <div class="card-right">
                           <el-image style="width: 110px; height: 80px" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"  />
                           <div class="entry-button" v-if="item.scaleStatus==0" @click="entryClick(item,3)">出净菜</div>
                        </div>
                        </div>
                    </el-card>
                  <div class="status-box" :class="{inactivestatus:item.scaleStatus!=0}"> {{item.scaleStatus!=0?'已加工':'待加工'}}</div>

               </div>
               </div>
              </div>
            </el-scrollbar>
          </el-main>
        </div>
        <!-- 底部 -->
        <el-footer v-if="isMerge">
          <div class="btn-box" @click="entryClick(tableData,4)">出净菜</div>
        </el-footer>

        <!-- 出净菜弹框 -->
        <scale-dialog ref="scaleDialogRef" @onSubmit="onSubmit" />
        <!-- 设置弹框 -->
        <set-dialog ref="setDialogRef" />
 
    </el-container>
  </template>
    
    <script lang="ts" setup>
  import { ref } from "vue";
  import { ElMessage,ElMessageBox } from 'element-plus'
  import { useRouter } from "vue-router";
  import scaleDialog from "@/views/warehouse/scaleDialog.vue";
  import setDialog from "@/views/warehouse/setDialog.vue";
  import { setToken } from "@/utils/auth";
  import { updateProcessOrderRecord, listProcessOrderRecord ,mergeProcessOrderRecord} from "@/api/processScale";
  import { getNowFormatDate, getTomorrowDate } from "@/utils/time";
  import { parseTime } from "@/utils/ruoyi.js";
  import { GetNumByUnit, toFixedDigit ,accSub} from "@/utils/uni.js";
  import { dicts } from "@/utils/getDict";

  import { initScale } from "@/api/outMaterial.js";//偏离值初始化
import { de } from "element-plus/es/locale";
  const router = useRouter();
  let dictObj = ref({});
  
  // 选项卡
  const tabsMenu=ref(['今日订单','明日订单'])
  // 当前选项卡下标
  let activeTab=ref(0)
  // 当前选择时间
  const date=new Date()
  // 当天时间
  let sameDay = parseTime(getNowFormatDate(date), "{y}-{m}-{d}");
  // 明天时间
  let tomorrowDay = parseTime(getNowFormatDate(getTomorrowDate(date)), "{y}-{m}-{d}");
  let time=sameDay
  // 选中值
  let value=ref('')
  // 弹框
  const scaleDialogRef = ref();
  // 设置弹框
  const setDialogRef = ref();
    // 合并交换
  const isMerge=ref(false)
  // 供应商选项
  const options = [
    {
      value: '',
      label: '全部',
    },
    {
      value: '0',
      label: '早餐',
    },
    {
      value: '1',
      label: '午餐',
    },
    {
      value: '2',
      label: '晚餐',
    }
  ]
  // 加工所有数据
  let allData=[]
  // 菜单选项下标
let menuActive=ref('0')

  const tableData = ref([]);
  const menuList = ref([]);
  // 偏离值的范围值
const range=ref(0)
// 偏离值初始化开关 1为开启 0为关闭
const offsetState=ref(0)
    //获取字典值
  const dictsFun = async () => {
  dictObj.value = await dicts(
    ["cutting_type"],
    dictObj.value
  );
  }
  dictsFun()
  // 获取字典值
  const getDictLabel = (code: string, value: string) => {
    if (dictObj.value[code]) {
      const dict = dictObj.value[code];
      return dict.find((item) => item.dictValue == value)?.dictLabel || value;
    }
    return value;
  }
// 菜单选项点击
const handleSelect = (index:string) => {
    menuActive.value=index
    tableData.value=[]
    const menuItem=menuList.value[index]
    if(index==0){
      tableData.value=selectedMenu(allData)
      return
    }
    
    const cuttingList=allData.filter(item=>item.cuttingType==menuItem.cuttingType)

    tableData.value=selectedMenu(cuttingList)
}
// 秤端初始化
const initScaleList = async () => {
  try {
  const res = await initScale()
  range.value = res.data.offset;
  offsetState.value = res.data.offsetState;
  } catch (error) {
    
  }

}
initScaleList()
  // 订单选项点击
  const handleClick = (index:number) => {
    activeTab.value=index
    time=activeTab.value===0?sameDay:tomorrowDay
    getScaleList()
  }
//   下拉选择
  const selectSupplier = (value:string='',type:number) => {
    getScaleList()
  }

  // 合并交换
  const handleMerge=() => {
    isMerge.value=!isMerge.value
  }
  // 设置
  const setClick=() => {
    setDialogRef.value.open({},1);
  }
  // 刷新
  const reload=() => {
    window.location.reload();
  }
  // 退出登陆
  const outLogin=() => {
     setToken("");
      router.push("/login");
  }
  

  // 出净菜
  const entryClick=(row:any,type:number)=> {

    
    if(type===3){
      isMerge.value=isMerge.value?false:isMerge.value
      scaleDialogRef.value.open(row,type,true);
      return
    }
      // 扁平化数据
      const data=flattenData(tableData.value)
      // 选择合并数据
      const selectedData=data.filter(item=>item.checked)
      if(selectedData.length==0)return ElMessage.warning('请选择需要合并出净菜的订单!!')
      // 判断合并菜品是否相同商品并且相同工序
      const isFig=selectedData.some((item)=>{
        let list=selectedData.filter(i=>i.goodsName===item.goodsName&&i.cuttingType===item.cuttingType)
        return list.length>1&&list.length===selectedData.length
      })
     
      if(!isFig)return ElMessage.warning('请选择相同商品、相同工序的合并出净菜!!')
      
      scaleDialogRef.value.open({infoList:selectedData},type,true);
        
        
      
  }
  // 列表请求
  const getScaleList = async () => {  

  // 请求参数
  const params = {
      pageNum: 1,
      pageSize: 2000,
      params: {
        // beginTime:"2024-08-01 00:00:00",
        beginTime: time + " 00:00:00",
        endTime: time + " 23:59:59",
      },
      status: 0,
      orderType:value.value,

  }
  listProcessOrderRecord(params).then(res=>{
    if (res.code == 200) {
      const data = res.rows
      data.forEach((item:any) => {
        item.orderTypeName=item.orderType==0?'早餐':item.orderType==1?'午餐':'晚餐'
        item.cuttingTypeName = getDictLabel("cutting_type", item.cuttingType);
      })

      menuList.value = data.filter((item,index)=>data.findIndex(i=>i.cuttingType===item.cuttingType)===index)
      menuList.value.unshift({cuttingTypeName:'全部',cuttingType:''})
      allData=data
      handleSelect(menuActive.value)
      // tableData.value = selectedMenu(data)

      console.log(tableData.value,'tableData.value');
      
    }else{}
  }).catch(err=>{ElMessage.error(err.message)})
  }
  getScaleList()

  // 过滤出对应的早餐 0、午餐 1、晚餐 2
  const selectedMenu = (data:any) => {
    let selectedList=data.filter((item:any,index:number)=>data.findIndex(i=>i.orderType===item.orderType)===index)
    // 根据订单类型排序
    selectedList.sort((a, b) => {
        return a.orderType - b.orderType
    });
    
    let orderList=selectedList.map((item)=>{return {orderTypeName:item.orderTypeName,orderType:item.orderType,list:data.filter(o=>o.orderType===item.orderType)}})
    return orderList
  }

  // 扁平化数据
  const flattenData = (data:any) => {
    let result = [];
    data.forEach((item:any) => {
      result.push(item);
      if (item.list && item.list.length > 0) {
        result = result.concat(flattenData(item.list));
      }
    });
    return result;
  }

  // 确认加工
  const onSubmit = (row:any,type:number) => {
  const data=JSON.parse(JSON.stringify(row))
  data.processWeight = GetNumByUnit(data.weigth, "kg", "g");
  data.processUserId = localStorage.getItem("userId");
  // data.beginTime=time+" 00:00:00"
  data.endTime=time+" 23:59:59"
  data.beginTime="2024-08-01 00:00:00"
  // data.endTime="2024-09-10 23:59:59"
  delete data.weigth
  delete data.checked
  delete data.peel
  delete data.returnWeight
  delete data.returnImage
  // 判断是否启用偏离值
  if(offsetState.value===1){
    // 启用偏离值进行比较
    offsetCompare(data,type);
  }else{
    // 直接入仓
    confirmOut(data,type);
  }

    
  }
  // 启用偏离值进行比较
  const offsetCompare = (data,type) => {
  // / 取 偏离值的绝对值
   // 理论值
   let theoryVal=activeTab.value==0?data.orderNo:data.unitOrderNo
  // 实际值
  let actualVal=activeTab.value==0?data.addWeight:data.addNumber
  // theoryVal 理论重量
  const num = accSub(theoryVal, actualVal);
  
  const numbe = range.value * -1;
  if (num >= numbe && num <= range.value) {
    confirmOut(data,type);
  } else {
    let message =
      num < range.value ? "多了！！！" : num > numbe ? "少了！！！" : "";
      ElMessage.warning(message);
    // row.butLoad = false;
  }
}
// 确认出净菜
const confirmOut = (data:any,type:number) => {
  ElMessageBox.alert('是否确认出净菜?','提示',{
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      showClose: false,
      showCancelButton:true,
      closeOnPressEscape:false,
      type: "warning",
      buttonSize: "large",
      cancelButtonClass: "cancel-button-class",
      customClass: "custom-class-text",
      confirmButtonClass: "confirm-button-class el-button--success",
  }).then(() => {
    if(type===4){
      confirmMerge(data)
      return
    }
    confirmEntry(data)
  }).catch(() => {
    console.log('cancel');
  });
}

// 出净菜接口
const confirmEntry = (data:any) => {
  data.scaleStatus=1
  updateProcessOrderRecord(data).then(res=>{
    if(res.code==200){
      ElMessage.success(res.msg)
      getScaleList()
    }else{
      ElMessage.error(res.msg)
    }
  })
}
  // 确认合并出净菜接口
  const confirmMerge = (data:any) => {
    data.scaleStatus=1
    data.scaleProcessOrderRecordList=data.infoList.filter(item=>data.checkList.includes(item.processOrderId))
    delete data.infoList
    delete data.checkList
    mergeProcessOrderRecord(data).then(res=>{
      if(res.code==200){
        ElMessage.success(res.msg)
        isMerge.value=false
        getScaleList()
      }else{
        ElMessage.error(res.msg)
      }
    })
  }
  </script>
    
    <style scoped>
    .entry-card-box{
      display: flex;
      flex-direction: column;
    }
    .btn-box{
        color: #fff;
        font-weight: 500;
        border: 1px solid #fff;
        padding: 6.5px 10px;
        border-radius: 5px;
        margin-left: 15px;
        text-align: center;
    cursor: pointer;
    min-width: 70px;

    }
    .layout-container-demo {
      font-size: 25px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: fixed;
      width: 100%;
      height: 100vh;
      top: 0;
    }
  .layout-container-demo .el-header {
    position: relative;
    /* background-color: var(--el-color-primary-light-7); */
    background-color:rgba(6, 172, 83, 1) ;
    color: var(--el-text-color-primary);
    height:65px
  }
  .layout-container-demo .el-footer{
    background-color:rgba(6, 172, 83, 1) ;
    color: var(--el-text-color-primary);
    position: relative;
  }
  .layout-container-demo .el-aside {
    color: var(--el-text-color-primary);
    background: #fff;
  }
  .layout-container-demo .el-menu {
    border-right: none;
  }
  .layout-container-demo .el-main {
    padding: 0;
  }
  .layout-container-demo .toolbar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    right: 20px;
  }

  .goodsTabs{
      background:#fff ;
      color: #06AC53;
      padding: 2px;
      border-radius: 5px;
      margin-left: 20px;
    cursor: pointer;
  
  }
  .tabsText{
      padding: 5px 20px;
  }
  .activeTabs{
      color: #fff;
      background: #06AC53;
      border-radius: 5px;
      
  }
  .supplierSelect{
      width: 21%;
      margin-left: 20px;
  }
  >>>.supplierSelect .el-input{
      font-size: 25px;
      height: 44px;
  
  }
  >>>.supplierSelect .el-input__inner, .el-select-dropdown__item.selected{
      color: #06AC53;
  
  }
  .menu-item{
      border-bottom: 1px solid #eee;
      font-size: 25px;
  }
  
  .el-menu-item.is-active{
      background: #1cb563d6;
      /* color: #fff; */
  
  }
  .cont-title{
      border-bottom: 1px solid rgba(121, 121, 121, 1);
      width: 20%;
  }
  .cont-card{
      margin:10px 0;
      background: rgba(240, 255, 247, 1);
      border-color: rgba(3, 172, 84, 1);
      position: relative;
      width: calc(100% - 30px);
      height: calc(100% - 20px);
  
  }
  >>> .cont-card .el-card__body{
      padding:15px  10px 10px;
  }
  .card-title{
      color: #03AC54;
      margin-bottom: 10px;
      font-size: 20px;
  }
  .font-weight-bold{
      font-weight: bold;
      margin: 5px 0;
  }
  .card-left{
      margin-left: 2px;
      font-size: 12px;
  }
  .card-bottom{
      font-size:18px ;
      margin-top: 10px;
      align-items: flex-end;
  }
  .entry-button{
      color: #03AC54;
      border:1px solid rgba(3, 172, 84, 1);
      border-radius: 5px;
      padding: 2px 10px;
      width: 80px;
    cursor: pointer;
    font-size: 23px;
    margin-top: 5px;
    text-align: center;
    margin-left: 18px;
  
  }


  >>>.el-input-number__increase,>>> .el-input-number__decrease {
      border-radius: 50%;
  }
  
  >>> .card-bottom .el-input__wrapper{
      box-shadow: none;
      background: transparent;
  }
  
  >>> .card-bottom  .el-input__inner{
      background: #fff;
  }

  .entry-card-item{
      position: relative;
      min-width:calc(100% / 4.2);position:relative;margin-right:10px;
  }
  .status-box{
      font-size: 18px;
      background: #00c988;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      color: #fff;
      position: absolute;
      width: 29px;
      text-align: center;
      top: 50%;
      right: -0.5px;
      /* height: 125px; */
      transform: translateY(-50%);
      padding: 25px 0;
  }
  .inactivestatus{
      background: #d9dbe0;
  }
  
  
  /* 屏幕小于1280px */
  @media screen and (max-width: 1280px) {
    .cont {
      width: 100%;
      margin: 0 auto;
    }
  }
  /*  屏幕小于1520或大于1280 */
  @media screen and (max-width: 1520px) and (min-width: 1280px) {
    .cont {
      width: 100%;
      margin: 0 auto;
    }
  }
  /* 屏幕大于1520px */
  @media screen and (min-width: 1520px) {
    .cont {
      width: 75%;
      margin: 0 auto;
    }
  }
  </style>
  
<style lang="scss">
.card-checkbox .el-checkbox__input.is-checked .el-checkbox__inner{
  background: #06AC53;
  border-color: #06AC53;
  // border-width: 5px;
  color: #06AC53;
}
.card-checkbox .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #06AC53;
}
 .card-checkbox{
    position: absolute;
    top: -5px;
    right: -5px;
}
.card-checkbox .el-checkbox__inner{
border-radius: 50%;
}
.layout-container-demo .el-footer{
  .btn-box{
    position: absolute;
    right: 50px;
    top: 5px;
  }
}
.card-checkbox .el-checkbox.el-checkbox--large .el-checkbox__inner{
  width: 23px;
  height: 23px;
}
.card-checkbox .el-checkbox__inner::after{
  height: 12px;
  width: 5px;
  left: 8px;
}
</style>